import { createReducer, on } from '@ngrx/store';
import { setScatterPlot } from '../scatter-plot.actions';
import { setChartId } from './chart-id.action';
export const chartId = createReducer(null, on(setChartId, (state, action) => {
    return action.chartId;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot.chartId;
}));
